(function () {
  // Prevent double init if the file is injected twice (Shopify dev/hotreload)
  if (window.__MBE_ANALYTICS_INIT__) return;
  window.__MBE_ANALYTICS_INIT__ = true;

  function deviceType() {
    try {
      return window.innerWidth < 768 ? 'mobile' : 'desktop';
    } catch (e) {
      return 'unknown';
    }
  }

  function baseParams() {
    return {
      device: deviceType(),
      page_path: (typeof location !== 'undefined' && location.pathname) ? location.pathname : '',
      page_title: (typeof document !== 'undefined' && document.title) ? document.title : ''
    };
  }

  /**
   * Global helper used by your map code.
   * Usage:
   *   window.mbeTrack('category_select', { category_key: 'museums', dataset_key: 'cyprus-xxx.json' })
   */
  window.mbeTrack = function (eventName, params) {
    if (!eventName) return;

    var payload = {};
    try {
      // merge base + params
      payload = Object.assign({}, baseParams(), (params || {}));
    } catch (e) {
      payload = params || {};
    }

    // Prefer GA4 gtag
    if (typeof window.gtag === 'function') {
      try {
        window.gtag('event', String(eventName), payload);
        return;
      } catch (e) {}
    }

    // Optional: if GA4 isn't ready yet, queue events and flush later
    window.__MBE_ANALYTICS_QUEUE__ = window.__MBE_ANALYTICS_QUEUE__ || [];
    window.__MBE_ANALYTICS_QUEUE__.push({ name: String(eventName), payload: payload });
  };

  // Try to flush queued events when gtag becomes available
  function flushQueue() {
    if (typeof window.gtag !== 'function') return;
    var q = window.__MBE_ANALYTICS_QUEUE__;
    if (!Array.isArray(q) || !q.length) return;

    while (q.length) {
      var item = q.shift();
      try { window.gtag('event', item.name, item.payload); } catch (e) {}
    }
  }

  // Flush soon + on load
  setTimeout(flushQueue, 500);
  window.addEventListener('load', flushQueue);
})();